import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import * as moment from "moment";
import { Json2csvService } from '../../services/json2csv.service';
import { PurchaseOrderService } from '../../services/purchaseOrder.service';
import { CompaniesService } from "../../services/companies.service";
import { PurchaseOrdersSearchFactory } from '../../shared/factories/purchaseOrders/PurchaseOrdersSearch.factory';
import { DropDownList } from '../../models/DropDownList.model';
import { LocalStorage } from "../../shared/wrappers/LocalStorage";
import { Company } from '../../models/Company.model';
import { BlanketAgreementInvoice, FormattedItemsForBlanketAgreementInvoice, Item, PurchaseOrder } from '../../models/PurchaseOrder.model';
import { CompetenceProvider } from "../../shared/providers/enums/billing-letter/competence-provider";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { GUARDS } from '../../shared/auth/Roles';
import  *  as _ from "lodash";
import { ProjectFinancialService } from '../../services/projectFinancial.service';
import { UserService } from '../../services/user.service';
import { ErrorHandlerProvider } from '../../shared/providers/errorHandler.provider';
import { ConsultantService } from '../../services/consultant.service';
import { ExcellenceCentersService } from "../../services/excellenceCenters.service";
import { ExcellenceCenter } from "../../models/ExcellenceCenter.model";
import { Industry } from "../../models/Industry.model";
import { IndustriesService } from "../../services/industries.service";
import { FilterBuilder } from '../../shared/builders/filter.builder';

import { AwsService } from '../../services/aws.service';
import { BehaviorSubject } from 'rxjs';

type SupportCenter = ExcellenceCenter;

@Component({
    selector: 'app-purchase-order',
    templateUrl: './purchase-order.component.html',
    styleUrls: ['./purchase-order.component.scss']
})
export class PurchaseOrderComponent implements OnInit {
    @ViewChild("buttonModalDuplicate") buttonModalDuplicate: ElementRef;
    @ViewChild("buttonModalCancel") buttonModalCancel: ElementRef;

    loading: boolean;
    purchaseOrders: PurchaseOrder[] = new Array<PurchaseOrder>();
    purchaseOrdersExport: PurchaseOrder[] = new Array<PurchaseOrder>();
    multipleApprovalPurchaseOrder = [];
    purchaseAux: PurchaseOrder = new PurchaseOrder();
    valueAux: number = 0;
    percentAux: number = 0;
    purchaseAuxValid: boolean = false;
    commonHelper: CommonHelper = new CommonHelper();
    datePickerOptions = this.commonHelper.getDatePickerOptions();
    competenceYears = this.commonHelper.listLastYears();
    competences = this.competenceProvider.competences;
    
    companies: any[] = new Array<any>();
    customers: Company[] = new Array<Company>();
    consultants: any[] = new Array<any>();
    supportCenters: Array<SupportCenter> = [];
    excellenceCenters: Array<ExcellenceCenter> = [];
    industries: Array<Industry> = [];
    projects: Array<any> = [];
    groups: Array<any> = [];
    subDivision: Array<any> = [];
    months: Array<any> = [];
    yearList;
    loggedUser;
    managers = []
    GUARDS = GUARDS;
    verifyStateCancellationReason: Boolean = false;
    canSave: Boolean = true;
    blockPermission = [GUARDS.CONTROLLERSHIP];

    purchaseOrdersSearch;
    apportionmentExport: boolean = false;
    purchaseOrdersSearchFactory = new PurchaseOrdersSearchFactory();

    dropDownListMonths: DropDownList[] = new Array<DropDownList>();
    dropDownListStatus: DropDownList[] = new Array<DropDownList>();
    $dropDownListCompanies: BehaviorSubject<DropDownList[]> = new BehaviorSubject<DropDownList[]>([]);
    $dropDownListCustomers: BehaviorSubject<DropDownList[]> = new BehaviorSubject<DropDownList[]>([]);
    $dropDownListProjects: BehaviorSubject<DropDownList[]> = new BehaviorSubject<DropDownList[]>([]);
    dropDownListGroups: DropDownList[] = new Array<DropDownList>();
    dropDownListSubDivision: DropDownList[] = new Array<DropDownList>();
    dropDownListApprovers: DropDownList[] = new Array<DropDownList>();
    dropDownListSupportCenters: DropDownList[] = new Array<DropDownList>();
    dropDownListIndustries: DropDownList[] = new Array<DropDownList>();
    dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();

    selectedMonthsItems: DropDownList[] = new Array<DropDownList>();
    selectedDivisionsItems: DropDownList[] = new Array<DropDownList>();
    selectedStatusItems: DropDownList[] = new Array<DropDownList>();
    selectedCompaniesItems: DropDownList[] = new Array<DropDownList>();
    selectedCustomersItems: DropDownList[] = new Array<DropDownList>();
    selectedProjectsItems: DropDownList[] = new Array<DropDownList>();
    selectedGroupsItems: DropDownList[] = new Array<DropDownList>();
    selectedSubDivisionItems: DropDownList[] = new Array<DropDownList>();
    selectedApprovers: DropDownList[] = new Array<DropDownList>();
    selectedSupportCenterItems: DropDownList[] = new Array<DropDownList>();
    selectedIndustriesItems: DropDownList[] = new Array<DropDownList>();
    selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();

    dropDownSubDivisionSettings = {};
    dropDownGrupsSettings = {};
    dropDownMonthsSettings = {};
    dropDownDivisionsSettings = {};
    dropDownStatusSettings = {};
    dropDownCompaniesSettings = {};
    dropDownCustomersSettings = {};
    dropDownProjectsSettings = {};
    dropDownFornSettings = {};
    dropDownCompanies: any;
    dropDownCompaniesList: any = [];
    dropDownApproversSettings: {};
    dropDownSupportCentersSettings: {};
    dropDownIndustriesSettings: {};
    dropDownExcellenceCentersSettings: {};

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;
    labelDocEntryInvoice: string = '';
    isBlanketAgreement = false;

    constructor(
        private competenceProvider: CompetenceProvider,
        private purchaseService: PurchaseOrderService,
        private localStorage: LocalStorage,
        private json2csvService: Json2csvService,
        private projectsFinancialService: ProjectFinancialService,
        private filterBuilder: FilterBuilder,
        private companiesService: CompaniesService,
        private userService: UserService,
        public toastr: ToastsManager,
        private errorHandler: ErrorHandlerProvider,
        private excellenceCentersService: ExcellenceCentersService,
        private industriesService: IndustriesService,
        private consultantService: ConsultantService,
        private awsService: AwsService,
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.loggedUser = this.localStorage.retrieve('user');
        this.yearList = this.commonHelper.listLastYears();
        this.months = this.commonHelper.multiSelectMonths();
        this.purchaseOrdersSearch = this.purchaseOrdersSearchFactory.newSearch();

        if (this.localStorage.retrieve("purchase-order"))
            this.setFilters();

        this.projectsFinancialService
            .getProjectsAndCustomers()
            .then(response => {
                this.customers = response.customers;
                this.customers = _.sortBy(this.customers, "name");
                this.projects = response.projects;
                this.$dropDownListProjects.next(this.commonHelper.getDropDownListItems(this.projects, "_id", "name"))
            });
        this.companiesService.listVendors().then(companies => {
            this.companies = companies.map(company => ({ ...company, name: company.companyName, type: 'Fornecedor - Empresa' }));
            this.consultantService.listAll(false).then(consultants => {
                this.consultants = consultants
                    .filter(consultantFilter => consultantFilter.sapCardCode && consultantFilter.contract && consultantFilter.contract.companyName && consultantFilter.contract.kind == 1)
                    .map(consultantMap => ({ ...consultantMap, name: consultantMap.contract.companyName, type: 'Fornecedor - Consultor PJ' }));
                this.companies = [...this.companies, ...this.consultants];
                this.$dropDownListCustomers.next(this.commonHelper.getDropDownListItems(this.customers, "_id", "name"))
                this.$dropDownListCompanies.next(this.commonHelper.getDropDownListItems(this.companies, "_id", "name"))
            });
        });
        this.groups = await this.companiesService.listAllGroupsWithBillings();
        this.subDivision = await this.projectsFinancialService.getAllSubDivisions();
        this.managers = await this.userService.getAllUsers();

        const typeOneCenters = await this.excellenceCentersService.getAll();

        this.excellenceCenters = typeOneCenters.filter(ec => ec.type == 1);
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.supportCenters = typeOneCenters.filter(ec => ec.type == 2);
        this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

        this.industries = await this.industriesService.getAll();

        this.dropDownListMonths = this.commonHelper.getDropDownListItems(this.months, "_id", "name");
        this.dropDownListStatus = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllStatusRefund(), "StatusRefund");
        this.dropDownListGroups = this.commonHelper.getDropDownListItems(this.groups, "_id", "name");
        this.dropDownListApprovers = this.commonHelper.getDropDownListItems(this.managers, "_id", "name")
        this.dropDownListSupportCenters = this.commonHelper.getDropDownListItems(this.supportCenters, "_id", "name");
        this.dropDownListIndustries = this.commonHelper.getDropDownListItems(this.industries, "_id", "name");
        this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(this.excellenceCenters, "_id", "name");

        this.dropDownMonthsSettings = this.commonHelper.getDropDownSettings(false, 'Meses', true, 'Marcar todos os meses', 'Desmarcar todos os meses', true,null, '');
        this.dropDownDivisionsSettings = this.commonHelper.getDropDownSettings(false, 'Divisões', false, 'Marcar todas as divisões', 'Desmarcar todas as divisões', true,null, '');
        this.dropDownStatusSettings = this.commonHelper.getDropDownSettings(false, 'Status', false, 'Marcar todos os status', 'Desmarcar todos os status', true,null, '');
        this.dropDownFornSettings = this.commonHelper.getDropDownSettings(false, 'Fornecedor', false, 'Marcar todos os selecionados', 'Desmarcar todos os selecionados', true,null, '');
        this.dropDownGrupsSettings = this.commonHelper.getDropDownSettings(false, 'Grupos de empresas', false, 'Marcar todos os selecionados', 'Desmarcar todos os selecionados', true,null, '');
        this.dropDownCustomersSettings = this.commonHelper.getDropDownSettings(false, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true,null, '');
        this.dropDownProjectsSettings = this.commonHelper.getDropDownSettings(false, 'Projetos', false, 'Marcar todos os projetos', 'Desmarcar todos os projetos', true,null, '');
        this.dropDownSubDivisionSettings = this.commonHelper.getDropDownSettings(false, 'Frente de Negócios', false, 'Marcar todas as divisões', 'Desmarcar todas as divisões', true,'division', '');
        this.dropDownApproversSettings = this.commonHelper.getDropDownSettings(false, 'Aprovadores', false, '', '', true, '', '');
        this.dropDownSupportCentersSettings = this.commonHelper.getDropDownSettings(false, 'Área de suporte', true, 'Marcar todos as áreas de suporte', 'Desmarcar todos as áreas de suporte', true, null , '');
        this.dropDownIndustriesSettings = this.commonHelper.getDropDownSettings(false, 'Setores', true, 'Marcar todos os setores', 'Desmarcar todos os setores', true, null , '');
        this.dropDownExcellenceCentersSettings = this.commonHelper.getDropDownSettings(false, 'Centro de Excelência', true, 'Marcar todos os centros de excelência', 'Desmarcar todos os centros de excelência', true, null , '');

        this.checkPermissions();

        await this.search(1);
        this.loading = false;
    }

    async search(page?: number, toexport?: boolean) {
        let limit, skip;
        this.loading = true;
        this.currentPage = page ? page : 1;
        this.purchaseOrdersSearch.skip = (this.currentPage - 1) * this.purchaseOrdersSearch.limit;
        if (toexport) {
            limit = this.purchaseOrdersSearch.limit;
            skip = this.purchaseOrdersSearch.skip;
            this.purchaseOrdersSearch.filterAnticipation = false;
            delete this.purchaseOrdersSearch.limit;
            delete this.purchaseOrdersSearch.skip;
        }

        this.purchaseOrdersSearch.months = [];
        this.purchaseOrdersSearch.divisions = [];
        this.purchaseOrdersSearch.statusPurchaseOrders = [];
        this.purchaseOrdersSearch.companies = [];
        this.purchaseOrdersSearch.customers = [];
        this.purchaseOrdersSearch.projects = [];
        this.purchaseOrdersSearch.groups = [];
        this.purchaseOrdersSearch.subDivision = [];
        this.purchaseOrdersSearch.approvers = [];
        this.purchaseOrdersSearch.industries = [];
        this.purchaseOrdersSearch.excellenceCenters = [];
        this.purchaseOrdersSearch.supportCenters = [];
        this.purchaseOrdersSearch.username = this.loggedUser.username;
        this.purchaseOrdersSearch.isBlanketAgreement = this.isBlanketAgreement;
        for (let month of this.selectedMonthsItems)
            this.purchaseOrdersSearch.months.push(month.id);

        for (let d of this.selectedDivisionsItems)
            this.purchaseOrdersSearch.divisions.push(parseInt(d.id));

        for (let s of this.selectedStatusItems)
            this.purchaseOrdersSearch.statusPurchaseOrders.push(parseInt(s.id));

        for (let comp of this.selectedSubDivisionItems)
           this.purchaseOrdersSearch.subDivision.push(comp.id);

        for (let comp of this.selectedCompaniesItems)
            this.purchaseOrdersSearch.companies.push(comp.id);

        for (let comp of this.selectedGroupsItems)
            this.purchaseOrdersSearch.groups.push(comp.id);

        for (let c of this.selectedCustomersItems)
            this.purchaseOrdersSearch.customers.push(c.id);

        for (let p of this.selectedProjectsItems)
            this.purchaseOrdersSearch.projects.push(p.id);

        for (let ap of this.selectedApprovers)
            this.purchaseOrdersSearch.approvers.push(ap.id);

        for (let cs of this.selectedSupportCenterItems)
            this.purchaseOrdersSearch.supportCenters.push(cs.id);

        for (let ec of this.selectedExcellenceCentersItems)
            this.purchaseOrdersSearch.excellenceCenters.push(ec.id);

        for (let ind of this.selectedIndustriesItems)
            this.purchaseOrdersSearch.industries.push(ind.id);

        this.purchaseOrders = await this.purchaseService.search(this.purchaseOrdersSearch);
        this.totalItems = this.purchaseOrdersSearch.totalItems;

        if (toexport) {
            this.purchaseOrdersSearch.limit = limit;
            this.purchaseOrdersSearch.skip = skip;
            this.purchaseOrdersSearch.filterAnticipation = true;
        } else {
            this.purchaseOrders = this.purchaseOrders.map(p => {
                p = this.checkPartialApproval(p);
                p.transcriptManagers = this.transcriptApprovers(p.managers);
                p.transcriptSubDivisions = this.transcriptSubDivisions(p);
                return p;
            });
            // TODO: verificar se multipleApprovalPurchaseOrder > 0 p/ true no checkbox (limpando com a paginação)
        }
        this.loading = false;
    }

    async export() {

        await this.search(1, true);
        let purchaseData = [];
        //if(!this.apportionmentExport){
        this.purchaseOrders.forEach(purchaseOrder => {
            let auxDivision: any[] = [];
            let auxPurchase: any;
            if (this.selectedDivisionsItems.length > 0) {
                auxDivision = this.selectedDivisionsItems.map(d => d.id);
                auxPurchase = [...purchaseOrder.items].filter(f => auxDivision.indexOf(f.division) > -1);
            } else {
                auxPurchase = [...purchaseOrder.items];
            };
            purchaseOrder = this.checkPartialApproval(purchaseOrder);

            let purchaseOrderItems = this.buildItemsForPurchaseOrder(purchaseOrder.items) as FormattedItemsForBlanketAgreementInvoice;

            if (purchaseOrder.isBlanketAgreement && purchaseOrder.blanketAgreementInvoices &&
                purchaseOrder.blanketAgreementInvoices.length) {
                    purchaseOrder.blanketAgreementInvoices.forEach((agreementInvoice: BlanketAgreementInvoice & { items: FormattedItemsForBlanketAgreementInvoice}) => {
                        agreementInvoice.items = purchaseOrderItems;
                        const orderLine = this.excelLines(purchaseOrder, purchaseOrderItems, agreementInvoice)
                        let lines = this.apportionmentExport ? this.makeApportionmentLines(orderLine, purchaseOrder, agreementInvoice.value) : [orderLine];
                        purchaseData.push(...lines);
                    })
                } else {
                    auxPurchase.forEach(item => {
                        let purchaseRegister = this.excelLines(purchaseOrder, item)

                        let lines = this.apportionmentExport ? this.makeApportionmentLines(purchaseRegister, purchaseOrder, item.value) : [purchaseRegister];
                        purchaseData.push(...lines);
                    });
                }
        });

        this.json2csvService.export(
            purchaseData,
            `relatório de pedidos - ${new Date().toLocaleDateString('pt-br')}`
        );
        this.loading = false;
    };

    excelLines(purchaseOrder, items, agreementInvoice?: BlanketAgreementInvoice & {items: FormattedItemsForBlanketAgreementInvoice}) {
        let approvers = this.transcriptApprovers(purchaseOrder)
                .replaceAll('&#10004;', 'S')
                .replaceAll('&#10006;', 'N')
                .replaceAll('&#8857;', '')
                .replaceAll('&#9679;', '');
        if(this.loggedUser.permission == 'controllership'){
            approvers = ''
        }
        const subDivisionAux = !agreementInvoice && items.project ? purchaseOrder.objProjectFinancials.find(pAux => pAux._id === items.project._id) : null;

        const defaultPurchaseOrderLines = this.makeDefaultExcelLines(purchaseOrder, items);
        const excelLines = {
            ...defaultPurchaseOrderLines,
            "Aprovador": approvers,
            "Frente de Negócio": subDivisionAux && subDivisionAux.subDivision ? subDivisionAux.subDivision.name : "-"
        };

        if (purchaseOrder.isBlanketAgreement) {
            return this.makeAgreementInvoiceExcelLine(purchaseOrder, excelLines, agreementInvoice);
        }
        return excelLines;
    }

    makeDefaultExcelLines(purchaseOrder: PurchaseOrder, item) {
        const subDivisionAux = item.project ? purchaseOrder.objProjectFinancials.find(pAux => pAux._id === item.project._id) : null;

        return {
            "ID Pedido": purchaseOrder._id,
            "Fornecedor": purchaseOrder.company ? purchaseOrder.company.name : "-",
            "CNPJ": purchaseOrder.company ? purchaseOrder.company.cnpj : "-",
            "Código PN": purchaseOrder.company ? purchaseOrder.company.sapCardCode : "-",
            "Antecipação": purchaseOrder.anticipationCode == "" ? 'Não' : 'Sim',
            "Aprovador": null,
            "Requisitante": purchaseOrder.requester ? purchaseOrder.requester.name : "-",
            "Motivo do cancelamento": purchaseOrder.cancellationReason ? purchaseOrder.cancellationReason: "-",
            "Competência": this.competenceProvider.findCompetence(purchaseOrder.competence),
            "Ano": purchaseOrder.competenceYear,
            "Vencimento": purchaseOrder.dueDate ? moment(purchaseOrder.dueDate).utc().format("DD/MM/YYYY") : "-",
            "Status": purchaseOrder["partialApproval"] ? 'Aprovado parcialmente' : this.commonHelper.transcriptStatusRefund(purchaseOrder.status),
            "Tipo de Serviço": subDivisionAux && subDivisionAux.subDivision ? subDivisionAux.subDivision.name : "-",
            "Item": item.itemName ? item.itemName : item.sapItemCode ? item.sapItemCode : '-',
            "Setor": !this.apportionmentExport && purchaseOrder.industries ? this.transcriptDistribution(purchaseOrder.industries) : ' - ',
            "Centro de Excelência": !this.apportionmentExport && purchaseOrder.excellenceCenters ? this.transcriptDistribution(purchaseOrder.excellenceCenters) : ' - ',
            "Área de Suporte": !this.apportionmentExport && purchaseOrder.supportCenters ? this.transcriptDistribution(purchaseOrder.supportCenters) : ' - ',
            "Valor": item.value ? item.value.toLocaleString("pt-BR",{maximumFractionDigits : 3}) : "-",
            "Cliente": item.customer && item.customer.name ? item.customer.name : "-",
            "Projeto": item.project && item.project.name ? item.project.name : "-",
            "Origem": purchaseOrder.origin == 1 ? 'Financial' : 'SAP',
            "Observações": purchaseOrder.observation,
            "Data de Criação": purchaseOrder.created ? moment(purchaseOrder.created).utc().format("DD/MM/YYYY") : "-",
            "Data de Aprovação": purchaseOrder.approvalDate ? moment(purchaseOrder.approvalDate).utc().format("DD/MM/YYYY") : "-",
            "Data de Pagamento": purchaseOrder.paymentDate ? moment(purchaseOrder.paymentDate).utc().format("DD/MM/YYYY") : "-",
            "Forma de Pagamento": purchaseOrder.paymentMethod ? this.commonHelper.transcriptPaymentMethodPurchaseOrder(purchaseOrder.paymentMethod) : "-",
            "Nº pedido SAP": purchaseOrder ? purchaseOrder.sapDocNum : "-",
            "Pedido Guarda-chuva": purchaseOrder.isBlanketAgreement ? "Sim" : "Não",
            "Guarda-chuva código": purchaseOrder.blanketAgreementCode ? purchaseOrder.blanketAgreementCode : "-",
            "Guarda-chuva valor acumulado": purchaseOrder.blanketAgreementAccumulatedValue ? purchaseOrder.blanketAgreementAccumulatedValue : "-",
            "Guarda-chuva saldo remanescente": Number(purchaseOrder.blanketAgreementRemainingValue) >= 0 ? purchaseOrder.blanketAgreementRemainingValue : "-",
        }
    }

    makeAgreementInvoiceExcelLine(purchaseOrder: PurchaseOrder, excelLines: {}, agreementInvoice: BlanketAgreementInvoice & { items: FormattedItemsForBlanketAgreementInvoice }) {
        const subDivisionForBlanketAgreementInvoice = this.getSubDivisionForBlanketAgreementInvoicee(purchaseOrder);
        const makeItemWithValueAndQuantity = []
        purchaseOrder.items.forEach((purchaseOrderItem: Item) => {
            makeItemWithValueAndQuantity.push(
                `Nome: ${purchaseOrderItem.itemName} - Quantidade: ${purchaseOrderItem.quantity}x - Valor: R$${purchaseOrderItem.value.toLocaleString("pt-BR",{maximumFractionDigits : 3})}`
            )
        });
        return {
            ...excelLines,
            "Competência": agreementInvoice && agreementInvoice.competence ? this.competenceProvider.findCompetence(agreementInvoice.competence) : "-",
            "Ano": agreementInvoice && agreementInvoice.competenceYear ? agreementInvoice.competenceYear : "-",
            "Vencimento": agreementInvoice && agreementInvoice.dueDate ? moment(agreementInvoice.dueDate).utc().format("DD/MM/YYYY") : "-",
            "Frente de Negocios": subDivisionForBlanketAgreementInvoice && subDivisionForBlanketAgreementInvoice.length ? subDivisionForBlanketAgreementInvoice.join(" | ") : "-",
            "Item": agreementInvoice && agreementInvoice.items.itemName && agreementInvoice.items.itemName.length > 0 ? agreementInvoice.items.itemName.map((itemName: string) => itemName).join(" | ") : '-',
            "Valor rateado": agreementInvoice && agreementInvoice.value ? agreementInvoice.value : "-",
            "Valor Item": makeItemWithValueAndQuantity && makeItemWithValueAndQuantity.length > 0 ? makeItemWithValueAndQuantity.join(" | ") : "-",
            "Grupo": agreementInvoice && agreementInvoice.items.companyGroup ? agreementInvoice.items.companyGroup : "-",
            "Cliente": agreementInvoice && agreementInvoice.items.customer ? agreementInvoice.items.customer : "-",
            "Projeto": agreementInvoice && agreementInvoice.items.project ? agreementInvoice.items.project : "-",
            "Nº pedido SAP": agreementInvoice && agreementInvoice.sapDocNum ? agreementInvoice.sapDocNum : "-",
            "NF": agreementInvoice && agreementInvoice.nf ? agreementInvoice.nf : "-"
        }
    }

    getSubDivisionForBlanketAgreementInvoicee(purchaseOrder: PurchaseOrder) {
        const hasSubDivision = purchaseOrder.isBlanketAgreement &&
        (purchaseOrder.items && purchaseOrder.items.length > 0) ?
            purchaseOrder.items.map((item: Item) => {
            if (item.project) {
                return purchaseOrder.objProjectFinancials
                .find(pAux => pAux._id === item.project._id)
            }
        }) : null;
        let subDivisionForBlanketAgreementInvoice: string[] = [];
        if (hasSubDivision && hasSubDivision.length) {
            for (const project of hasSubDivision) {
                if (project && project.subDivision && project.subDivision.name) {
                    subDivisionForBlanketAgreementInvoice.push(project.subDivision.name);
                }
            }
        }
        return subDivisionForBlanketAgreementInvoice;
    }

    buildItemsForPurchaseOrder(items: Item[]) {
        let formattedItemsForExcel = {};
        items.forEach((purchaseItem: Item) => {
            for (const [key, value] of Object.entries(purchaseItem)) {
                if (formattedItemsForExcel[key] && formattedItemsForExcel[key].length) {
                    formattedItemsForExcel[key].push(value);
                } else {
                    formattedItemsForExcel[key] = [];
                    formattedItemsForExcel[key].push(value);
                }
            }
        })
        for (let key in formattedItemsForExcel) {
            if (formattedItemsForExcel[key] && formattedItemsForExcel[key].length > 0) {
                //Destruturação para formatar os objetos abaixo
                if (key == "project" || key == "customer" || key == "companyGroup") {
                    formattedItemsForExcel[key] = formattedItemsForExcel[key].map(({name}) => name).join(" | ");
                }
            }
        }
        return formattedItemsForExcel;
    }

    checkPermissions() {
        this.loggedUser = this.localStorage.retrieve('user');
        if(this.blockPermission.includes(this.loggedUser.permission)) {
            this.canSave = false;
        }
    }

    onChange() {
        this.localStorage.persist("purchase-order", {
            purchaseOrdersSearch: this.purchaseOrdersSearch,
            selectedMonthsItems:this.selectedMonthsItems,
            selectedSubDivisionItems: this.selectedSubDivisionItems,
            selectedStatusItems:this.selectedStatusItems,
            selectedCompaniesItems: this.selectedCompaniesItems,
            selectedCustomersItems: this.selectedCustomersItems,
            selectedProjectsItems: this.selectedProjectsItems,
            selectedIndustriesItems: this.selectedIndustriesItems,
            selectedExcellenceCentersItems: this.selectedExcellenceCentersItems,
            selectedSupportCenterItems: this.selectedSupportCenterItems
        });
    }

    setFilters(){
        let storage = this.localStorage.retrieve("purchase-order");
        if(storage.purchaseOrdersSearch)
            this.purchaseOrdersSearch = storage.purchaseOrdersSearch;
        this.selectedMonthsItems = storage.selectedMonthsItems?storage.selectedMonthsItems:[];
        this.selectedStatusItems = storage.selectedStatusItems?storage.selectedStatusItems:[];
        this.selectedCompaniesItems = storage.selectedCompaniesItems?storage.selectedCompaniesItems:[];
        this.selectedCustomersItems = storage.selectedResponsibleItems?storage.selectedResponsibleItems:[];
        this.selectedProjectsItems = storage.selectedProjectsItems?storage.selectedProjectsItems:[];
        this.selectedSupportCenterItems = storage.selectedSupportCenterItems?storage.selectedSupportCenterItems:[];
        this.selectedExcellenceCentersItems = storage.selectedExcellenceCentersItems?storage.selectedExcellenceCentersItems:[];
        this.selectedIndustriesItems = storage.selectedIndustriesItems?storage.selectedIndustriesItems:[];
    }

    openModalDuplicate(purchase: any){
        this.purchaseAux = new PurchaseOrder();
        this.purchaseAux = { ...purchase };
        this.purchaseAux._id = '';
        this.purchaseAux.status = 1;
        this.purchaseAux.competence = 0;
        this.purchaseAux.competenceYear = 0;
        this.purchaseAux.origin = 1;
        this.purchaseAux.sapIntegrated = false;
        this.purchaseAux.sapDocEntry = '';
        this.purchaseAux.sapDocNum = '';
        this.purchaseAux.observation = purchase.observation;
        this.purchaseAux.changed = new Date();
        this.purchaseAux.created = new Date();
        this.purchaseAux.dueDate = new Date();
        this.purchaseAux.requester._id = this.loggedUser._id;
        this.purchaseAux.requester.name = this.loggedUser.name;
        this.purchaseAux.managers = this.purchaseAux.managers.map(m => {
            m.approved = false; return m;
        });
        this.purchaseAux.items = purchase.items.map(i => { // correção de referencia inválida de items
            return {
                ...i,
                percent: i.value / purchase.value * 100
            }
        });
        this.valueAux = 0;
        this.percentAux = 100;

        this.validatePurchaseAux();
        this.buttonModalDuplicate.nativeElement.click();
    }

    async openModalCancel(purchase: any){
        try {
            this.verifyStateCancellationReason = true;
            this.purchaseAux = new PurchaseOrder();
            this.purchaseAux = { ...purchase };
            this.labelDocEntryInvoice = '';

            //check if purchaseorder has invoice
            if(this.purchaseAux.status == 1) {
                this.buttonModalCancel.nativeElement.click();
            } else {
                this.loading = true;
                const res = await this.purchaseService.getSapDocEntryHasInvoice(this.purchaseAux.sapDocEntry);
                this.loading = false;
                if(res && res.hasInvoice) this.labelDocEntryInvoice = 'ATENÇÃO: este pedido de compra possui vínculo com nota fiscal no SAP';
                this.buttonModalCancel.nativeElement.click();
            }
        } catch(err) {
            this.loading = false;
        }
    }

    async duplicate(){
        try{
            if(!this.purchaseAuxValid) return;

            let response = await this.purchaseService.create(this.purchaseAux);
            if(response._id){
                this.toastr.success('Pedido de Compra duplicado com sucesso. E-mail enviado ao gestor');
                await this.search(1);
            } else {
                this.errorHandler.interceptError(response, 'Pedido de compra');
            }
            this.purchaseAux = new PurchaseOrder();
            this.valueAux = 0;
            this.percentAux = 100;
        } catch(err) {
            this.errorHandler.interceptError(err, 'Pedido de compra');
        }
    }

    async clear(){
        this.purchaseAux = new PurchaseOrder();
        this.valueAux = 0;
        this.percentAux = 100;
    }

    changeValuePurchaseAux() {
        const itemValues = this.purchaseAux.items && this.purchaseAux.items.length > 0 ?
            this.purchaseAux.items.reduce((acc, { value }) => acc + value, 0) : 0;
        const itemPercent = this.purchaseAux.items && this.purchaseAux.items.length > 0 ?
            this.purchaseAux.items.reduce((acc, { percent }) => acc + parseFloat(percent), 0) : 0;
        this.valueAux = this.purchaseAux.value - itemValues;
        this.percentAux = itemPercent;
        this.validatePurchaseAux();
    }

    changePercentItemAux(index) {
        const valuePercent = this.purchaseAux.value / 100 * this.purchaseAux.items[index].percent;
        this.purchaseAux.items[index].value = valuePercent;
        this.changeValuePurchaseAux();
    }

    changeValueItemAux(index) {
        const percent = this.purchaseAux.items[index].value / this.purchaseAux.value * 100;
        this.purchaseAux.items[index].percent = percent;
    };

    validatePurchaseAux() {
        for(let item of this.purchaseAux.items) {
            if(!item.value || item.value <= 0){
                this.purchaseAuxValid = false; return;
            }
        }

        const sumItemValues = this.purchaseAux.items.reduce((acc, { value }) => acc + value, 0);
        if(parseFloat(sumItemValues.toFixed(2)) != this.purchaseAux.value){
            this.purchaseAuxValid = false; return;
        }

        this.purchaseAuxValid = true;
    }

    verifyColorColumn(status: number) {
        switch(status){
            case 1: return "aprovacao-pendente";
            case 2: return "pagamento-pendente";
            case 3: return "pago";
            case 4: return "reprovado";
            case 5: return "cancelado";
            default: return '';
        }
    }

    transcriptApprovers(purchaseOrder) {
        if(purchaseOrder.managers && purchaseOrder.managers.length) {
            const managers = purchaseOrder.status != 1 || purchaseOrder.managers.some(m => m.optional && m.approved) ?
                purchaseOrder.managers.filter(m => m.approved || !m.optional) : purchaseOrder.managers;
            return managers.map(m => (`${m.optional ? '&#8857;' : '&#9679;'} ${m.name} ${m.approved ? '(&#10004;)' : '(&#10006;)'}`)).join(' / ');
        }
        return "";
    }

    TranscriptManagersOfDate(managers){
        let approval = managers.map((c) =>
            c.approvalDate ?  new Date(c.approvalDate).getTime() : 0
        ).sort((c,d)=> d - c).map(c =>` ${c > 0 ? moment(c).format('DD/MM/YYYY'):''}`)
        return approval[0]
    };

    transcriptDistribution(distributions){
        if(distributions.length > 0)
            return distributions.map(distribution => distribution.name).join(' | ');
        return "-"
    }

    transcriptDivisions(items) {
        let divisions = items.map(d => d.division);
        divisions = divisions.filter((item, pos) => divisions.indexOf(item) == pos);
        return divisions.map(d => this.commonHelper.transcriptDivisionGroup(d)).join(' / ');
    }

    transcriptSubDivisions(purchase) {
        let subDivision = purchase.objProjectFinancials.filter(pAux => pAux.subDivision)
            .map(item => item.subDivision.name);
        if(subDivision.length > 0)
            return subDivision.filter((item, pos) => subDivision.indexOf(item) == pos).join(' / ');
        return "";
    }

    async cancelPurchaseOrder() {
        try {
            let response;
            if(this.purchaseAux.cancellationReason && this.purchaseAux.cancellationReason !== ''){
                response = await this.purchaseService.cancel(this.purchaseAux._id, this.purchaseAux);
            }
            if(response._id){
                this.toastr.success('Pedido de Compra cancelado com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Pedido de compra');
            }
            await this.search(1);
            this.clear();
        } catch(err) {
            console.log(err)
            this.errorHandler.interceptError(err, 'Pedido de compra');
            this.clear();
        }
    }

    checkPartialApproval(purchaseOrder) {
        const approver = purchaseOrder.managers.find(m => m.email == this.loggedUser.username);
        purchaseOrder['isApprover'] = false;
        if(approver) {
            const canNotApprove = approver.optional && purchaseOrder.managers.some(m => m.optional && m.approved)
            if(!canNotApprove)
                purchaseOrder['isApprover'] = true;
            if(purchaseOrder.status == 1 && approver.approved)
                purchaseOrder['partialApproval'] = true;
        }
        return purchaseOrder;
    }

    updateCheckList(value: any) {
        const isChecked = value.target.checked;
        if(isChecked && !this.multipleApprovalPurchaseOrder.includes(value.target.id)) {
            this.multipleApprovalPurchaseOrder.push(value.target.id);
        } else {
            this.multipleApprovalPurchaseOrder = this.multipleApprovalPurchaseOrder.filter(purchaseId => purchaseId !== value.target.id);
        }
    }

    checkAll(value:any) {
        let checksItems = document.querySelectorAll('[name="purchase-item-box"]');
        let checkBoxes = Array.prototype.slice.call(checksItems);
        let isChecked = value.target.checked;
        this.multipleApprovalPurchaseOrder = [];
        if(isChecked){
            for(let check of checkBoxes){
                check.checked = true;
                this.multipleApprovalPurchaseOrder.push(check.getAttribute('id'));
            }
        } else {
            for(let check of checkBoxes){
                check.checked = false;
                this.multipleApprovalPurchaseOrder = [];
            }
        }
    }

    clearMultiSelect() {
        let checksItems = document.querySelectorAll('[name="purchase-item-box"],[name="purchase-all-box"]');
        let checkBoxes = Array.prototype.slice.call(checksItems);
        for(let check of checkBoxes)
            check.checked = false;
        this.multipleApprovalPurchaseOrder = [];
    }

    async approveMultiplePurchase() {
        try {
            this.loading = true;
            let purchaseSuccess = 0, purchaseError = 0;
            for(let purchaseOrderId of this.multipleApprovalPurchaseOrder) {
                let respApproval = await this.purchaseService.approval(purchaseOrderId, {
                    manager: this.loggedUser
                });
                if(respApproval._id)
                    purchaseSuccess++;
                else
                    purchaseError++;
            }

            if(purchaseSuccess && !purchaseError)
                this.toastr.success(`${purchaseSuccess} pedido(s) de compra aprovado(s) com sucesso`, 'Operação finalizada');
            else if(!purchaseSuccess && purchaseError)
                this.toastr.warning(`Erro ao aprovar ${purchaseError} pedido(s) de compra`, 'Operação finalizada');
            else {
                this.toastr.success(`${purchaseSuccess} pedido(s) de compra aprovado(s) com sucesso`);
                this.toastr.warning(`Erro ao aprovar ${purchaseError} pedido(s) de compra`);
            }

            this.clearMultiSelect();
            this.loading = false;
            await this.search(1);
        } catch(err){
            this.errorHandler.interceptError(err, 'Pedido de compra');
        }
    }

    makeApportionmentLines(buildLine, orders, lineTotalValue) {
        const makeLine = (buildLine, industryName, excellenceCenterName, supportCenterName, value) => {
            return {
                ...buildLine,
                "Setor": industryName,
                "Centro de Excelência": excellenceCenterName,
                "Área de Suporte": supportCenterName,
                "Valor rateado": value.toLocaleString("pt-BR",{maximumFractionDigits : 3})
            }
        }

        let apportionmentLines = [];
        const existsIndustries = orders.industries.length > 0;
        const existsExcellenceCenters = orders.excellenceCenters.length > 0;
        const existsSupportCenters = orders.supportCenters.length > 0;

        if(!existsIndustries && !existsExcellenceCenters && !existsSupportCenters) {
            apportionmentLines.push({ ...buildLine });
        } else if(existsIndustries) {
            orders.industries.forEach(industry => {
                if(existsExcellenceCenters) {
                    orders.excellenceCenters.forEach(excellenceCenter => {
                        if(existsSupportCenters) {
                            orders.supportCenters.forEach(supportCenter => {
                                const apportionmentValue = this.apportionmentCalculator(
                                    lineTotalValue,
                                    industry.percentage,
                                    excellenceCenter.percentage,
                                    supportCenter.percentage
                                )
                                const line = makeLine(buildLine, industry.name, excellenceCenter.name, supportCenter.name, apportionmentValue)
                                apportionmentLines.push(line);
                            });
                        } else {
                            const apportionmentValue = this.apportionmentCalculator(
                                lineTotalValue,
                                industry.percentage,
                                excellenceCenter.percentage,
                                100
                            )
                            const line = makeLine(buildLine, industry.name, excellenceCenter.name, "-", apportionmentValue)
                            apportionmentLines.push(line);
                        }
                    })
                } else if(existsSupportCenters) {
                    orders.supportCenters.forEach(supportCenter => {
                        const apportionmentValue = this.apportionmentCalculator(
                            lineTotalValue,
                            industry.percentage,
                            100,
                            supportCenter.percentage
                        )
                        const line = makeLine(buildLine, industry.name, "-", supportCenter.name, apportionmentValue)
                        apportionmentLines.push(line);
                    });
                } else {
                    const apportionmentValue = this.apportionmentCalculator(
                        lineTotalValue,
                        industry.percentage,
                        100,
                        100
                    )
                    const line = makeLine(buildLine, industry.name, "-", "-", apportionmentValue)
                    apportionmentLines.push(line);
                }
            });
        } else if(existsExcellenceCenters) {
            orders.excellenceCenters.forEach(excellenceCenter => {
                if(existsSupportCenters) {
                    orders.supportCenters.forEach(supportCenter => {
                        const apportionmentValue = this.apportionmentCalculator(
                            lineTotalValue,
                            100,
                            excellenceCenter.percentage,
                            supportCenter.percentage
                        )
                        const line = makeLine(buildLine, "-", excellenceCenter.name, supportCenter.name, apportionmentValue)
                        apportionmentLines.push(line);
                    });
                } else {
                    const apportionmentValue = this.apportionmentCalculator(
                        lineTotalValue,
                        100,
                        excellenceCenter.percentage,
                        100
                    )
                    const line = makeLine(buildLine, "-", excellenceCenter.name, "-", apportionmentValue)
                    apportionmentLines.push(line);
                }
            })
        } else if(existsSupportCenters) {
            orders.supportCenters.forEach(supportCenter => {
                const apportionmentValue = this.apportionmentCalculator(
                    lineTotalValue,
                    100,
                    100,
                    supportCenter.percentage
                )
                const line = makeLine(buildLine, "-", "-", supportCenter.name, apportionmentValue)
                apportionmentLines.push(line);
            });
        }
        return apportionmentLines;
    }

    apportionmentCalculator(value, percentage1, percentage2, percentage3) {
        return value * (percentage1 / 100) * (percentage2 / 100) * (percentage3 / 100);
    }

    checkMatchBetweenPurchaseAndApprover(purchaseOrder) {
        const approverOfPurchase = purchaseOrder.managers.find(m => m.email === this.loggedUser.username);
        const requesterOfPurchase = purchaseOrder.requester.email === this.loggedUser.username;
        return (approverOfPurchase || requesterOfPurchase ||
            this.loggedUser.permission == GUARDS.FINANCES || this.loggedUser.permission == GUARDS.CONTROLLERSHIP || this.loggedUser.permission == GUARDS.ACCOUNTING
        ) ? true : false;
    }

    arrayToText(list) {
        if(!list || !list.length) return;
        const apportionment = list.map(item => `${item.name} (${item.percentage}%) R$ ${Number(item.value).toFixed(2)}`);
        return apportionment.join(' | ');
    }

    verifyCancellationReason() {
        if(this.purchaseAux.cancellationReason && this.purchaseAux.cancellationReason.length < 3){
            this.purchaseAux.cancellationReason = "";
            return this.toastr.warning("O motivo do cancelamento deve conter ao menos 3 caracteres", "Limite mínimo de caracteres não atingido");
        }

        if(this.purchaseAux.cancellationReason && this.purchaseAux.cancellationReason.length > 500){
            this.purchaseAux.cancellationReason = this.purchaseAux.cancellationReason.substring(0, 500);
            return this.toastr.warning("O texto deve conter até 500 caracteres", "Limite máximo de caracteres atingido");
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/purchase-order.component.ts